import { CircularProgress, Grid, Typography } from '@mui/material';
import ViewTable from '../view-table';

// Types for ShowTableOrLoad
interface ShowTableOrLoadProps {
  loadingData: boolean;
  visibleData: any[];
  visibleDimensions: any[];
  visibleEmissions: any[];
}

export const ShowTableOrLoad = ({
  loadingData,
  visibleData,
  visibleDimensions,
  visibleEmissions,
}: ShowTableOrLoadProps) => (
  <>
    {loadingData ? (
      <Grid container item>
        <Typography>Loading data</Typography>
        <CircularProgress />
      </Grid>
    ) : (
      <ViewTable data={visibleData} dimensions={visibleDimensions} emissions={visibleEmissions} />
    )}
  </>
);
